/**
 * @flow
 * @relayHash 08771828552bb2164e46d387d222c457
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteUserInput = {
  id: string,
  clientMutationId: string,
};
export type DeleteUserMutationVariables = {|
  input: DeleteUserInput
|};
export type DeleteUserMutationResponse = {|
  +deleteUser: ?{|
    +deletedId: ?string
  |}
|};
*/

/*
mutation DeleteUserMutation(
  $input: DeleteUserInput!
) {
  deleteUser(input: $input) {
    deletedId
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: "LocalArgument",
        name: "input",
        type: "DeleteUserInput!",
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: "LinkedField",
        alias: null,
        name: "deleteUser",
        storageKey: null,
        args: [
          {
            kind: "Variable",
            name: "input",
            variableName: "input",
            type: "DeleteUserInput!"
          }
        ],
        concreteType: "DeleteUserPayload",
        plural: false,
        selections: [
          {
            kind: "ScalarField",
            alias: null,
            name: "deletedId",
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: "Request",
    operationKind: "mutation",
    name: "DeleteUserMutation",
    id: null,
    text:
      "mutation DeleteUserMutation(\n  $input: DeleteUserInput!\n) {\n  deleteUser(input: $input) {\n    deletedId\n  }\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "DeleteUserMutation",
      type: "Mutation",
      metadata: null,
      argumentDefinitions: v0,
      selections: v1
    },
    operation: {
      kind: "Operation",
      name: "DeleteUserMutation",
      argumentDefinitions: v0,
      selections: v1
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '3da4e1bed137683b9ab82995bee1bd52';
module.exports = node;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/DeleteUserMutation.graphql.js